export default __webpack_public_path__ + "static/joko-app-screenshot-home-1-en@2x-433c465e135439b0cb8d91a1110e9e67.png";